import { render, staticRenderFns } from "./home-banners.vue?vue&type=template&id=10f52f72&"
import script from "./home-banners.vue?vue&type=script&lang=js&"
export * from "./home-banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports